import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const stripeApi = createApi({
  reducerPath: 'stripeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_STRIPE}`,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['Stripe'],
  endpoints: (builder) => ({
    generateToken: builder.mutation({
      query: (payload) => ({
        url: '/payment_methods',
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: payload,
      }),
      providesTags: ['Token'],
    }),
  }),
});

export const { useGenerateTokenMutation } = stripeApi;
